import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import type { BackgroundTask } from "@/hooks/useBackgroundTasks";

interface TaskStatusBarProps {
  activeTasks: BackgroundTask[];
  tasks: BackgroundTask[];
}

export function TaskStatusBar({ activeTasks, tasks }: TaskStatusBarProps) {
  const recentCompleted = tasks.filter(
    (t) =>
      t.status === "completed" &&
      t.completedAt &&
      Date.now() - new Date(t.completedAt).getTime() < 30_000,
  );
  const recentFailed = tasks.filter(
    (t) =>
      t.status === "failed" &&
      t.completedAt &&
      Date.now() - new Date(t.completedAt).getTime() < 30_000,
  );

  if (
    activeTasks.length === 0 &&
    recentCompleted.length === 0 &&
    recentFailed.length === 0
  ) {
    return null;
  }

  return (
    <div className="space-y-1 border-t bg-gray-50 px-6 py-2">
      {activeTasks.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-2 text-sm text-gray-600"
        >
          <Loader2 className="h-3.5 w-3.5 animate-spin text-blue-500" />
          <span className="truncate">
            Working on: {task.instruction.slice(0, 80)}
            {task.instruction.length > 80 ? "..." : ""}
          </span>
        </div>
      ))}
      {recentCompleted.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-2 text-sm text-green-700"
        >
          <CheckCircle2 className="h-3.5 w-3.5" />
          <span>Background task completed</span>
        </div>
      ))}
      {recentFailed.map((task) => (
        <div
          key={task.id}
          className="flex items-center gap-2 text-sm text-red-600"
        >
          <XCircle className="h-3.5 w-3.5" />
          <span>
            Task failed: {task.error?.slice(0, 80) ?? "Unknown error"}
          </span>
        </div>
      ))}
    </div>
  );
}
